import { useCallback, useEffect, useMemo, useState } from 'react';
import cls from 'classnames';
import PhoneScixe from '../h5/sciex/Index';
import PcScixe from '../pc/sciex/index';
const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export default () => {
  return isMobileDevice() ? <PhoneScixe /> : <PcScixe />;
};
